import { X } from "lucide-react";
import { formatSeatLabel } from "@/lib/utils/seatLabel";

type Props = {
    nombre: string;
    mesaId: string;
    seatId: string;
    precio: number;
    color: string;
    onRemove: () => void;
}

export function EntradasSeleccionadasCard({ nombre, mesaId, seatId, precio, color, onRemove }: Props) {
    return (
        <div className="bg-white/5 backdrop-blur-sm rounded-lg p-4 flex items-center justify-between hover:bg-white/10 transition-colors">
            <div className="flex items-start gap-3 flex-1">
                {/* Color indicator */}
                <div
                    className="w-1 h-16 rounded-full flex-shrink-0"
                    style={{ backgroundColor: color }}
                />

                <div className="flex-1 min-w-0">
                    {/* Tipo de entrada */}
                    <h3 className="text-white font-semibold text-base mb-1">
                        {nombre}
                    </h3>

                    {/* Mesa y Asiento */}
                    {seatId && (
                        <div className="text-sm text-white/70">
                            <span className="text-white font-medium">{formatSeatLabel(seatId)}</span>
                        </div>
                    )}

                    {/* Precio */}
                    <div className="mt-2">
                        <span className="text-lg font-bold text-white">
                            ${precio}
                        </span>
                    </div>
                </div>
            </div>

            {/* Botón eliminar */}
            <button
                onClick={onRemove}
                className="ml-3 p-2 rounded-lg bg-red-500/20 hover:bg-red-500/30 text-red-400 hover:text-red-300 transition-colors flex-shrink-0"
                aria-label="Eliminar entrada"
            >
                <X size={20} />
            </button>
        </div>
    );
};

